import React, { useEffect, useState } from 'react';
import { Texture } from 'pixi.js'
import { Sprite, Container, AnimatedSprite } from '@inlet/react-pixi'
import { ease } from 'pixi-ease'

import { GetExtraLevelAssetByTraitGroupId } from '../../../actions/home-actions'
import ResilienceDolphinAssetHolder from './ExtraMaxLevelAsset/ResilienceDolphinAssetHolder'

const ResilienceMaxLevel = ({ _xPos, _yPos, _traitGroupScore, _traitGroupId }) => {

    const [assetCount, setAssetCount] = useState({ ship: 0, dolphin: 0 });

    const shipSprite1 = React.useRef();
    const shipSprite2 = React.useRef();
    const shipSprite3 = React.useRef();
    const shipSprite4 = React.useRef();
    const shipSprite5 = React.useRef();
    const shipSprite6 = React.useRef();

    let ship1Texture = Texture.from(`./assets/images/components/island/particle/maxLevel/resilience/aac_yellow.png`);
    let ship2Texture = Texture.from(`./assets/images/components/island/particle/maxLevel/resilience/bouy_yellow_01.png`);
    let ship3Texture = Texture.from(`./assets/images/components/island/particle/maxLevel/resilience/patrolboat_yellow_01.png`);
    let ship4Texture = Texture.from(`./assets/images/components/island/particle/maxLevel/resilience/sailboat_yellow_01.png`);
    let ship5Texture = Texture.from(`./assets/images/components/island/particle/maxLevel/resilience/tugboat_yellow_01.png`);
    let ship6Texture = Texture.from(`./assets/images/components/island/particle/maxLevel/resilience/Yatch_Yellow_01.png`);

    useEffect(() => {
        const initExtraLevelAsset = async () => {
            let response = await GetExtraLevelAssetByTraitGroupId(_traitGroupId);
            //console.log("Extra Level Asset response:", response);
            let shipCount = 0;
            let dolphinCount = 0;
            if (response.data != null && response.data.length > 0) {
                //console.log("Extra Level Asset data:", response.data);
                response.data.forEach((item) => {
                    switch (item.seletctedItemName) {
                        case "Ship":
                            ++shipCount;
                            break;
                        case "Dolphin":
                            ++dolphinCount;
                            break;
                    }
                })

                setAssetCount({ ship: shipCount, dolphin: dolphinCount });
            }
        }
        initExtraLevelAsset();
    }, []);

    useEffect(() => {
        if (shipSprite1.current !== null && shipSprite1.current !== undefined) {
            ease.target(shipSprite1.current, { x: -15, y: 45 }, 0.001, { repeat: true, reverse: true })
        }
        if (shipSprite2.current !== null && shipSprite2.current !== undefined) {
            ease.target(shipSprite2.current, { x: -85, y: 135 }, 0.001, { repeat: true, reverse: true })
        }
        if (shipSprite3.current !== null && shipSprite3.current !== undefined) {
            ease.target(shipSprite3.current, { x: -155, y: 255 }, 0.001, { repeat: true, reverse: true })
        }
        if (shipSprite4.current !== null && shipSprite4.current !== undefined) {
            ease.target(shipSprite4.current, { x: 105, y: 85 }, 0.001, { repeat: true, reverse: true })
        }
        if (shipSprite5.current !== null && shipSprite5.current !== undefined) {
            ease.target(shipSprite5.current, { x: 55, y: 195 }, 0.001, { repeat: true, reverse: true })
        }
        if (shipSprite6.current !== null && shipSprite6.current !== undefined) {
            ease.target(shipSprite6.current, { x: -255, y: 205 }, 0.001, { repeat: true, reverse: true })
        }
    }, [assetCount]);

    return (
        <Container x={_xPos} y={_yPos}>
            {
                assetCount.ship > 0 ?
                    <Sprite x={-10} y={40} ref={shipSprite1}
                        texture={ship1Texture}
                        scale={{ x: 0.25, y: 0.25 }}
                    />
                    : <></>

            }
            {
                assetCount.ship > 1 ?
                    <Sprite x={-120} y={130} ref={shipSprite2}
                        texture={ship2Texture}
                        scale={{ x: 0.1, y: 0.1 }}
                    /> : <></>
            }
            {
                assetCount.ship > 2 ?
                    <Sprite x={-150} y={250} ref={shipSprite3}
                        texture={ship3Texture}
                        scale={{ x: 0.25, y: 0.25 }}
                    /> : <></>
            }
            {
                assetCount.ship > 3 ?
                    <Sprite x={100} y={90} ref={shipSprite4}
                        texture={ship4Texture}
                        scale={{ x: 0.25, y: 0.25 }}
                    /> : <></>
            }
            {
                assetCount.ship > 4 ?
                    <Sprite x={50} y={200} ref={shipSprite5}
                        texture={ship5Texture}
                        scale={{ x: 0.15, y: 0.15 }}
                    /> : <></>
            }
            {
                assetCount.ship > 5 ?
                    <Sprite x={-250} y={200} ref={shipSprite6}
                        texture={ship6Texture}
                        scale={{ x: 0.15, y: 0.15 }}
                    /> : <></>
            }
            <ResilienceDolphinAssetHolder _count={assetCount.dolphin} />
        </Container>
    );
};

export { ResilienceMaxLevel as default }